import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, startWith } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class LandingAuthService {
  private readonly oauthService = inject(OAuthService);

  readonly isAuthenticated = toSignal(
    this.oauthService.events.pipe(
      startWith(null),
      map(() => this.oauthService.hasValidAccessToken()),
    ),
    { initialValue: false },
  );

  hasValidToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  get stateCampaignId(): string | null {
    const state = this.oauthService.state;

    return state ? decodeURIComponent(state) : null;
  }

  login(campaignId: string | null): void {
    this.oauthService.initCodeFlow(campaignId ?? '', {
      ...this.campaignParams(campaignId),
      prompt: 'login',
    });
  }

  resumeLogin(campaignId: string | null): void {
    this.oauthService.initCodeFlow(
      campaignId ?? '',
      this.campaignParams(campaignId),
    );
  }

  register(campaignId: string | null): void {
    this.oauthService.initCodeFlow(campaignId ?? '', {
      ...this.campaignParams(campaignId),
      prompt: 'create',
    });
  }

  resetSession(): void {
    this.oauthService.logOut(true);
  }

  logout(): void {
    this.oauthService.logOut();
  }

  private campaignParams(campaignId: string | null): Record<string, string> {
    return campaignId ? { campaignId } : {};
  }
}
